import React, { useState } from "react";
import "./styles.css";

export default function Footer() {
  return (
    <div className="footer">
      <div className="footer-left"></div>
      <div className="footer-right">
        <div className="contact-us-header">
          <img
            alt="cat's taste"
            className="footer-cat-mouth"
            src="/assets/icons/cat-mouth.svg"
          />
          <div className="contact-us-title">Contact us</div>
        </div>
        <div className="footer-btn-wrapper">
          <a className="footer-btn" href="https://shopee.co.th/shop/582216451/">
            <img
              alt="cat's taste"
              className="footer-btn-img"
              src="/assets/icons/shopee-icon.svg"
            />
            <div className="footer-btn-img-title">SHOPEE</div>
          </a>
          <a
            className="footer-btn"
            href="https://www.lazada.co.th/shop/cat-s-taste"
          >
            <img
              alt="cat's taste"
              className="footer-btn-img"
              src="/assets/icons/lazada-icon.svg"
            />
            <div className="footer-btn-img-title">Lazada</div>
          </a>
          <a className="footer-btn" href="https://www.facebook.com/cats.taste">
            <img
              alt="cat's taste"
              className="footer-btn-img"
              src="/assets/icons/facebook-icon.svg"
            />
            <div className="footer-btn-img-title">Facebook</div>
          </a>
          <a
            className="footer-btn"
            href="https://www.instagram.com/cats.taste/"
          >
            <img
              alt="cat's taste"
              className="footer-btn-img"
              src="/assets/icons/instagram-icon.svg"
            />
            <div className="footer-btn-img-title">instragram</div>
          </a>
          <a className="footer-btn" href="https://twitter.com/cats_taste_th">
            <img
              alt="cat's taste"
              className="footer-btn-img"
              src="/assets/icons/twitter-icon.svg"
            />
            <div className="footer-btn-img-title">twitter</div>
          </a>
        </div>
        <div className="footer-contact-title-wrapper">
          <div className="footer-contact-title">
            All For Pet Co., Ltd. (Head Office)
          </div>
          <div className="footer-contact-subtitle">
            77/1 Moo 6, Nadi Subdistrict Mueang Samut
          </div>
          <div className="footer-contact-subtitle">
            Sakhon District Samut Sakhon 74000
          </div>
          <div className="footer-contact-subtitle">THAILAND</div>
        </div>
        <div className="footer-contact-container">
          <div className="footer-contact-wrapper">
            <img
              alt=""
              className="footer-contact-icon"
              src="/assets/icons/email-icon.svg"
            />
            <a
              className="footer-contact-desc"
              href="mailto: meow@catstaste.com"
            >
              meow@catstaste.com
            </a>
          </div>
          <div className="footer-contact-wrapper">
            <img
              alt=""
              className="footer-contact-icon"
              src="/assets/icons/phone-icon.svg"
            />
            <a className="footer-contact-desc" href="tel:061-519-2242">
              061 519 2242
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
